import { metalPanel, gameColors } from '@/shared/ui/game-theme';
import { GameIcon } from '@/shared/ui/game-icon';
import type { CharacterEncounter } from '../types/character.types';
import type { CharacterLanguage } from '../utils/character-labels';

function record(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}
function participantLabel(side: string, index: number, language: CharacterLanguage): string {
  const roles: Record<string, [string, string]> = {
    guard: ['Стражник', 'Guard'], bandit: ['Разбойник', 'Bandit'],
    hooligan: ['Хулиган', 'Hooligan'], brawler: ['Участник драки', 'Brawler'],
    civilian: ['Путник', 'Traveler'], unknown: ['Незнакомец', 'Stranger'],
  };
  const role = roles[side]?.[language === 'ru' ? 0 : 1] ?? (language === 'ru' ? 'Участник' : 'Participant');
  return `${role} №${index + 1}`;
}
function statusLabel(status: string, language: CharacterLanguage): string {
  const statuses: Record<string, [string, string]> = {
    active: ['Действует', 'Active'], healthy: ['Невредим', 'Healthy'],
    wounded: ['Ранен', 'Wounded'], surrendered: ['Сдался', 'Surrendered'],
    captive: ['В плену', 'Captive'], fled: ['Ушёл', 'Left'], dead: ['Погиб', 'Dead'],
  };
  return statuses[status]?.[language === 'ru' ? 0 : 1] ?? (language === 'ru' ? 'Состояние неизвестно' : 'Status unknown');
}

export function EncounterRoster({participants, metadata, language}: {
  participants: CharacterEncounter['participants']; metadata: unknown; language: CharacterLanguage;
}) {
  const ru = language === 'ru';
  if (!participants.length) return null;
  return <ul className="encounter-roster" aria-label={ru ? 'Участники встречи' : 'Encounter participants'}>
    {participants.map((participant, index) => {
      const candidate = record(metadata) ? metadata[participant.id] : null;
      const known = record(candidate) ? candidate : null;
      const name = known?.[ru ? 'labelRu' : 'labelEn'];
      const label = typeof name === 'string' && name.trim() && name.length <= 160 ? name : participantLabel(participant.side, index, language);
      const maxHP = known?.maxHP;
      const health = typeof maxHP === 'number' && Number.isSafeInteger(maxHP) && maxHP > 0 && maxHP >= participant.hp ? `${participant.hp} / ${maxHP}` : String(participant.hp);
      return <li key={participant.id} style={metalPanel}>
        <strong>{label}</strong>
        <span style={{ color: gameColors.health }}><GameIcon name="heart" size={13} /> {ru ? 'Здоровье' : 'Health'}: {health}</span>
        <span className="character-muted" style={{ color: gameColors.muted }}>{statusLabel(participant.status, language)}{known?.protected === true ? (ru ? ' · Под защитой' : ' · Under protection') : ''}</span>
      </li>;
    })}
  </ul>;
}
